import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Callback() {
  const { googleAuth } = useAuth();
  const [error, setError] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { setError("No session found. Please try again."); return; }
    (async () => {
      const res = await googleAuth(decodeURIComponent(m[1]));
      if (res.ok) nav("/app"); else setError(res.error);
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="dk-card p-8 max-w-sm text-center space-y-3">
        {error ? (
          <>
            <p style={{ color: "var(--error)" }}>{error}</p>
            <button className="btn btn-primary w-full" onClick={() => nav("/auth/login")}>Back to log in</button>
          </>
        ) : (
          <><Loader2 className="animate-spin mx-auto" style={{ color: "var(--sage)" }} /><p style={{ color: "var(--text-muted)" }}>Signing you in…</p></>
        )}
      </div>
    </div>
  );
}
